
import createValidatePropsMethod from './../lib/createValidatePropsMethod'

/**
 * Checks that the organization is a valid object and doesn't have invalid props.
 * Will throw if it does
 * @param {object} org
 */
const validateOrg = createValidatePropsMethod({
  'id': `Missing prop on organization 'id'.`,
  'name': `Missing prop on organization 'name'.`,
})


/**
 * Add an organization
 * @param {object} repository Expects object props of name, id
 */
export function addOrganization(organization){
  validateOrg(organization)
  return {
    type: 'ADD_ORGANIZATION',
    organization,
  }
}


// WEBPACK FOOTER //
// ./src/store/organizations/actions.js